import { useContext } from 'react';
import { FlexContext } from '../../../contexts/flexContext';
import { AppContext } from '../../../contexts/appContext';
import { IStructuredSnowplowEvent } from '../../useSnowplowTracker';
import useNavigation from '../../useNavigation';

export interface IFlexNavigateFinish {
  type: 'finish';
  relaunch: boolean;
  urlToOpen?: string;
  snowplowEvent?: IStructuredSnowplowEvent;
}

const useFlexNavigateFinish = () => {
  const { reinitializeApp } = useContext(AppContext);
  const flexContext = useContext(FlexContext);
  const navigation = useNavigation();

  const handleFlexNavigateFinish = (flexNavigate: IFlexNavigateFinish) => {
    // Relaunch the app if instructed.
    if (flexNavigate.relaunch && !flexNavigate.urlToOpen) {
      reinitializeApp();
      return;
    }

    // flexContext.finish may not be available when this hook is called within
    // FlexContextProvider itself (e.g. from a flex start config response), because
    // a component cannot consume its own context — useContext reads from the nearest
    // *parent* provider, which in that case is the empty default. Fall back to
    // navigation.pop directly, which achieves the same outcome.
    if (flexContext.finish) {
      flexContext.finish(flexNavigate.urlToOpen);
    } else {
      navigation.pop({ internalUrl: flexNavigate.urlToOpen, delta: 1 });
    }
  };

  return handleFlexNavigateFinish;
};

export default useFlexNavigateFinish;
